/*
* Generate a random ID for use as CSS class, form name, etc
*/
export function randomId(): string {
    return Math.random().toString(36).substr(2, 10);
}
